import { Box, DataTableAction, DataTableLabel, Group, Link, Text, Tooltip } from '@optiaxiom/react';

import { useInstanceId } from '@frontend/hooks';

import type { Notification } from '../../../types';
import { getDeepLinkPath, getNotificationVisuals } from '../../../utils';

type NotificationCellProps = {
  notification: Notification;
  onActivate: () => void;
};

export function NotificationCell({ notification, onActivate }: NotificationCellProps) {
  const { instanceId } = useInstanceId();
  const visuals = getNotificationVisuals(notification.type);
  const href = `/instances/${instanceId}${getDeepLinkPath(notification)}`;

  return (
    <Group gap="12" alignItems="start" w="full">
      {visuals && (
        <Box color={visuals.color} mt="2" flex="none">
          <visuals.Icon />
        </Box>
      )}
      <DataTableLabel asChild>
        <DataTableAction overflow="hidden" primary>
          <Link
            appearance="subtle"
            href={href}
            onClick={e => {
              e.preventDefault();
              onActivate();
            }}
          >
            <Group flexDirection="column" gap="2" overflow="hidden" w="full">
              <Text fontWeight={notification.is_read ? '400' : '600'} truncate>
                {notification.title}
              </Text>
              <Tooltip content={notification.message} delayDuration={0}>
                <Text fontSize="sm" color="fg.tertiary" lineClamp="1">
                  {notification.message}
                </Text>
              </Tooltip>
            </Group>
          </Link>
        </DataTableAction>
      </DataTableLabel>
    </Group>
  );
}
